import { EntryNode } from './EntryNode';
import { AgentNode } from './AgentNode';
import { FunctionNode } from './FunctionNode';
import { BranchNode } from './BranchNode';

export const nodeTypes = {
  entryNode: EntryNode,
  agentNode: AgentNode,
  functionNode: FunctionNode,
  branchNode: BranchNode,
};

export { EntryNode, AgentNode, FunctionNode, BranchNode };
